import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleFetchErrorsSwal } from '../../../shared/helpers/fetchHelpers';
import { notificationActions } from './notificationSlice';
import $ from 'jquery';

interface ReadAllNotificationsResponse {
    status: 'success' | 'error';
    data: null;
}

export const getNotification = createAsyncThunk(
    'notification/getNotification',
    async (_, thunkApi) => {
        //@ts-ignore
        const url = routable.getRoute('notificationsList');

        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            await handleFetchErrorsSwal(response);

            const { data, is_last_page } = await response.json();
            if (is_last_page) {
                thunkApi.dispatch(notificationActions.lastPageChange(is_last_page));
            }
            return data;
        } catch (e) {
            //@ts-ignore
            return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
        }
    }
);

export const loadMoreNotification = createAsyncThunk(
    'notification/loadMoreNotification',
    async (_, thunkApi) => {
        //@ts-ignore
        const url = routable.getRoute('notificationsList');
        const state = thunkApi.getState();
        //@ts-ignore
        const ids = await state.notificationReducer.notifications.ids;
        const lastId = ids.slice(-1)[0];

        try {
            const response = await fetch(`${url}?last_id=${lastId}`, {
                method: 'GET',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            await handleFetchErrorsSwal(response);

            const { data, is_last_page } = await response.json();

            if (is_last_page) {
                thunkApi.dispatch(notificationActions.lastPageChange(is_last_page));
            }

            return data;
        } catch (e) {
            //@ts-ignore
            return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
        }
    }
);

export const readAllNotifications = createAsyncThunk<
    ReadAllNotificationsResponse,
    void,
    { rejectValue: string }
>('notification/readAllNotifications', async (_, thunkApi) => {
    //@ts-ignore
    const url = routable.getRoute('notificationsSetIsViewedAll');

    thunkApi.dispatch(notificationActions.markAllAsViewed());

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        });

        await handleFetchErrorsSwal(response);
        const result: ReadAllNotificationsResponse = await response.json();

        if (result && result.status === 'success') {
            $('[data-action="notification"]').removeClass('notification-active');
            return result;
        }
    } catch (e) {
        thunkApi.dispatch(notificationActions.rollbackViewedNotifications());
        return thunkApi.rejectWithValue(e instanceof Error ? e.message : 'Неизвестная ошибка');
    }
});
